import { Content } from "@/services/content/types";
import * as ArticleTeaser from "./article";

type VerticalProps = {
  item: Content.Entry;
  hideDownPull?: boolean;
  hideTitle?: boolean;
};

const Vertical = (props: VerticalProps) => {
  if (
    props.item.sys.contentType.sys.id === "article" ||
    props.item.sys.contentType.sys.id === "externalContent"
  ) {
    return (
      <ArticleTeaser.vertical
        article={props.item}
        hideDownPull={props.hideDownPull}
        hideTitle={props.hideTitle}
      />
    );
  }

  console.warn(
    `${props.item.sys.contentType.sys.id} vertical teaser not implemented`,
  );

  return null;
};

export default Vertical;
